// Error codes (vienen en extensions del error GraphQL)
export const CREDIT_LINE_ERROR_CODES = {
  CREDIT_LINE_NOT_AVAILABLE: 'CREDIT_LINE_NOT_AVAILABLE',
  CREDIT_SUB_LINE_NOT_AVAILABLE: 'CREDIT_SUB_LINE_NOT_AVAILABLE',
  API_ERROR: 'API_ERROR',
};

// Warning codes (vienen en warningCode del resultado exitoso)
export const CREDIT_LINE_WARNING_CODES = {
  CREDIT_LINE_NOT_EXISTENT: 'CREDIT_LINE_NOT_EXISTENT',
  CREDIT_LINE_ALREADY_IN_EVALUATION: 'CREDIT_LINE_ALREADY_IN_EVALUATION',
};

export const CREDIT_LINE_ERROR_DIALOGS = {
  [CREDIT_LINE_ERROR_CODES.CREDIT_LINE_NOT_AVAILABLE]: {
    title: 'Cupo de factoring insuficiente',
    description: 'Tu cupo disponible no alcanza para cubrir las facturas seleccionadas.',
    useWarningIcon: false,
    showSuggestion: true,
    useEvaluateInvoices: false,
    showDebtors: false,
    buttonLabels: {
      primary: 'Evaluar Línea',
      secondary: 'Eliminar Facturas',
    },
  },
  [CREDIT_LINE_ERROR_CODES.CREDIT_SUB_LINE_NOT_AVAILABLE]: {
    title: 'Cupo de factoring insuficiente',
    description: 'Tu cupo disponible no alcanza para cubrir las facturas seleccionadas de:',
    useWarningIcon: false,
    showSuggestion: true,
    useEvaluateInvoices: false,
    showDebtors: true,
    buttonLabels: {
      primary: 'Evaluar Línea',
      secondary: 'Eliminar Facturas',
    },
  },
  [CREDIT_LINE_ERROR_CODES.API_ERROR]: {
    title: 'No se pudo completar tu solicitud',
    description: 'Por favor, intenta enviar tus facturas a evaluación nuevamente.',
    useWarningIcon: true,
    showSuggestion: false,
    useEvaluateInvoices: true,
    showDebtors: false,
    buttonLabels: {
      primary: 'REINTENTAR EVALUACIÓN',
      secondary: 'VOLVER',
    },
  },
};

export const CREDIT_LINE_WARNING_MESSAGES = {
  [CREDIT_LINE_WARNING_CODES.CREDIT_LINE_NOT_EXISTENT]: {
    title: 'Aún no cuentas con una línea aprobada. Esta cotización está sujeta al monto de línea que se te asigne.',
    description: 'Te informaremos tan pronto tengamos una respuesta para coordinar la firma del contrato y continuar con el financiamiento de tus facturas.',
  },
  [CREDIT_LINE_WARNING_CODES.CREDIT_LINE_ALREADY_IN_EVALUATION]: {
    title: 'Estamos en proceso de evaluación de aumento de línea. Te notificaremos tan pronto tengamos los resultados' },
};

export const getErrorCodeFromExtensions = (
  error,
) => error?.graphQLErrors?.[0]?.extensions?.code || null;

export const getDebtorNamesFromExtensions = (
  error,
) => error?.graphQLErrors?.[0]?.extensions?.debtor_names || [];

export const isCreditLineError = (
  errorCode,
) => Object.values(CREDIT_LINE_ERROR_CODES).includes(errorCode);
